document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.before-after-slider').forEach((slider) => {
    const revealLayer = slider.querySelector('.before-image');
    const handle = slider.querySelector('.slider-handle');

    if (!revealLayer || !handle) return;

    let isDragging = false;
    let rect = null;

    const measure = () => {
      rect = slider.getBoundingClientRect();
    };

    const updateFromClientX = (clientX) => {
      if (!rect) measure();
      const x = Math.max(rect.left, Math.min(clientX, rect.right));
      const pct = ((x - rect.left) / rect.width) * 100;

      slider.style.setProperty('--reveal-pct', `${pct}%`);
    };

    const start = (event) => {
      isDragging = true;
      measure();
      handle.classList.add('slider-handle--dragging');
      const clientX = event.clientX ?? event.touches?.[0]?.clientX;
      if (clientX != null) updateFromClientX(clientX);
    };

    const move = (event) => {
      if (!isDragging) return;
      event.preventDefault();
      const clientX = event.clientX ?? event.touches?.[0]?.clientX;
      if (clientX != null) updateFromClientX(clientX);
    };

    const end = () => {
      isDragging = false;
      handle.classList.remove('slider-handle--dragging');
    };

    slider.addEventListener('mousedown', start);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', end);

    slider.addEventListener('touchstart', start, { passive: false });
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('touchend', end, { passive: false });

    slider.addEventListener('click', (event) => {
      if (isDragging) return;
      measure();
      updateFromClientX(event.clientX);
    });

    window.addEventListener('load', () => {
      measure();
      updateFromClientX(rect.left + rect.width / 2);
    });

    window.addEventListener('resize', measure);
  });
});
